import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
const HighchartsMore = require('highcharts/highcharts-more');
HighchartsMore(Highcharts);

@Component({
  selector: 'app-community_sys',
  templateUrl: './community_sys.component.html',
  styleUrls: ['./community_sys.component.css']
})
export class Community_sysComponent implements OnInit {
  loading = false;
  now = '0';

  // ── 帳號管理 ──────────────────────────────────────────────
  account_list_raw: any[] = [];
  account_page = 1;
  account_page_size = 10;
  edit_data: any = null;
  default_data = {
    id: null, url: '', type: 'ig', account_name: '', agent_name: '', is_enable: '1'
  };

  // 帳號 filter
  acct_filter_type = '';
  acct_filter_agent = '';
  acct_filter_status = '';
  acct_filter_keyword = '';

  type_options = [
    { id: 'ig', name: 'Instagram' },
    { id: 'fb', name: 'Facebook' },
    { id: 'twitter', name: 'Twitter / X' },
    { id: 'thread', name: 'Threads' },
    { id: 'youtube', name: 'YouTube' },
    { id: 'tiktok', name: 'TikTok' },
    { id: 'xiaohongshu', name: '小紅書' },
  ];

  vendor_list: any[] = [];
  crawling_ids: Set<number> = new Set();

  // ── 每日統計 ──────────────────────────────────────────────
  stats_list: any[] = [];
  stats_page = 1;
  stats_page_size = 10;
  stats_total = 0;

  filter_date_start = '';
  filter_date_end = '';
  filter_type = '';
  filter_agent = '';
  filter_keyword = '';

  // 排序
  sort_column = 'target_date';
  sort_dir = 'desc'; // 'asc' | 'desc'

  // ── 圖表分析 ──────────────────────────────────────────────
  Highcharts: typeof Highcharts = Highcharts;
  chart_filter_date_start = '';
  chart_filter_date_end = '';
  chart_ready = false;
  // 經紀貢獻圓餅圖
  agentPieOptions: Highcharts.Options = {};
  agentPieUpdateFlag = false;
  // 經紀社群占比圓餅圖
  platformPieOptions: Highcharts.Options = {};
  platformPieUpdateFlag = false;
  chart_selected_agent = '';  // 用於選擇要看哪個經紀的社群占比
  agent_platform_data: any[] = [];
  // 經紀各社群折線圖（按指標分）
  trend_metric = 'post_count';
  trend_metrics = [
    { key: 'post_count',    label: '發文數' },
    { key: 'view_count',    label: '觀看次數' },
    { key: 'like_count',    label: '點讚數' },
    { key: 'comment_count', label: '留言數' },
    { key: 'share_count',   label: '分享次數' },
  ];
  trend_raw: any = { dates: [], metrics: {} };
  trend_platform = '';  // '' = 全部平台
  trend_platform_options: { id: string, name: string }[] = [];
  trendLineOptions: Highcharts.Options = {};
  trendLineUpdateFlag = false;

  // ── 經紀指標 ──────────────────────────────────────────────
  am_date_start = '';
  am_date_end = '';
  am_time: any = {
    startDate: moment().subtract(7, 'days'),
    endDate: moment()
  };
  am_timeset = [
    { type: 1, name: '今天', num: -0 },
    { type: 3, name: '昨天', num: -1 },
    { type: 1, name: '過去7天', num: -7 },
    { type: 1, name: '過去30天', num: -30 },
    { type: 2, name: '本月', num: 0 },
    { type: 2, name: '上個月', num: -1 },
    { type: 2, name: '上上個月', num: -2 },
  ];
  am_filter_vendor = '';
  am_show_help = false;
  am_summary_raw: any[] = [];
  am_trend_raw_full: any = { dates: [], new_users: [], post_count: [] };
  am_pie_raw: any[] = [];
  am_chart_ready = false;
  am_pie_options: Highcharts.Options = {};
  am_pie_update = false;
  am_bar_options: Highcharts.Options = {};
  am_bar_update = false;
  am_trend_metric = 'new_users';
  am_trend_metrics = [
    { key: 'new_users',  label: '新增用戶' },
    { key: 'post_count', label: '每日發文' },
  ];
  am_trend_raw: any = { dates: [], new_users: [], post_count: [] };
  am_trend_options: Highcharts.Options = {};
  am_trend_update = false;
  am_trend_visible = true;

  // ── 雷達圖：收益分類 ──
  am_radar_options: Highcharts.Options = {};
  am_radar_update = false;
  am_radar_raw: any[] = [];

  // ── 經紀表格排序 ──
  am_sort_col = '';
  am_sort_dir = 'desc';  // 'asc' | 'desc'

  // ── 明細彈窗排序 ──
  am_detail_sort_col = '';
  am_detail_sort_dir = 'desc';

  get am_summary(): any[] {
    let list = this.am_summary_raw;
    if (this.am_filter_vendor) {
      list = list.filter((r: any) => r.vendor_name === this.am_filter_vendor);
    }
    if (this.am_sort_col) {
      const dir = this.am_sort_dir === 'desc' ? -1 : 1;
      list = [...list].sort((a, b) => {
        const va = a[this.am_sort_col] ?? 0;
        const vb = b[this.am_sort_col] ?? 0;
        if (typeof va === 'string') return va.localeCompare(vb) * dir;
        return (va - vb) * dir;
      });
    }
    return list;
  }
  get am_vendor_options(): string[] {
    return this.am_summary_raw.map((r: any) => r.vendor_name);
  }
  get am_total_new_users(): number {
    return this.am_summary.reduce((s: number, r: any) => s + (r.new_users || 0), 0);
  }
  get am_avg_active_rate(): number {
    if (!this.am_summary.length) return 0;
    const sum = this.am_summary.reduce((s: number, r: any) => s + (r.active_rate || 0), 0);
    return Math.round((sum / this.am_summary.length) * 10) / 10;
  }
  get am_avg_churn(): number {
    if (!this.am_summary.length) return 0;
    const sum = this.am_summary.reduce((s: number, r: any) => s + (r.churn_rate || 0), 0);
    return Math.round((sum / this.am_summary.length) * 10) / 10;
  }
  get am_total_posts(): number {
    return this.am_summary.reduce((s: number, r: any) => s + (r.total_posts || 0), 0);
  }
  get am_total_lost(): number {
    return this.am_summary.reduce((s: number, r: any) => s + (r.lost_members || 0), 0);
  }
  get am_total_members(): number {
    return this.am_summary.reduce((s: number, r: any) => s + (r.total_members || 0), 0);
  }
  get am_total_online(): number {
    return this.am_summary.reduce((s: number, r: any) => s + (r.online_members || 0), 0);
  }
  get am_avg_daily_posts(): number {
    if (!this.am_summary.length) return 0;
    const sum = this.am_summary.reduce((s: number, r: any) => s + (r.daily_posts || 0), 0);
    return Math.round(sum * 10) / 10;
  }

  // ── 用戶明細 modal（新增用戶 / 上線人數 / 遺失人數 共用） ──
  am_detail_list: any[] = [];
  am_detail_title = '';
  am_detail_type = '';   // 'new_users' | 'online_members' | 'lost_members'
  am_show_detail_modal = false;
  am_detail_loading = false;
  am_detail_page = 1;
  am_detail_page_size = 20;

  get am_detail_paged(): any[] {
    const start = (this.am_detail_page - 1) * this.am_detail_page_size;
    return this.am_detail_list.slice(start, start + this.am_detail_page_size);
  }
  get am_detail_total_pages(): number {
    return Math.ceil(this.am_detail_list.length / this.am_detail_page_size) || 1;
  }
  get am_detail_pages(): number[] {
    const total = this.am_detail_total_pages;
    const cur = this.am_detail_page;
    const pages: number[] = [];
    let start = Math.max(1, cur - 2);
    let end = Math.min(total, cur + 2);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
      end = Math.min(total, start + 4);
    }
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  }

  private detail_type_labels: any = {
    new_users: '新增用戶',
    online_members: '上線人數',
    lost_members: '遺失人數',
  };

  open_member_detail(row: any, type: string, count: number) {
    if (!count || count <= 0) return;
    this.am_detail_type = type;
    this.am_detail_title = row.vendor_name + ' — ' + (this.detail_type_labels[type] || '') + '明細';
    this.am_detail_loading = true;
    this.am_show_detail_modal = true;
    this.am_detail_list = [];
    this.am_detail_page = 1;
    this.am_detail_sort_col = '';
    this.am_detail_sort_dir = 'desc';

    const body = {
      vid: row.vid,
      date_start: this.am_date_start,
      date_end: this.am_date_end,
      type: type,
    };
    this.httpClient.post<any>('/comm/get_community_member_detail.php', body).subscribe({
      next: res => {
        this.am_detail_loading = false;
        if (res?.status) {
          this.am_detail_list = res.data || [];
        }
      },
      error: () => { this.am_detail_loading = false; }
    });
  }

  close_member_detail() {
    this.am_show_detail_modal = false;
    this.am_detail_list = [];
  }

  am_toggle_sort(col: string) {
    if (this.am_sort_col === col) {
      this.am_sort_dir = this.am_sort_dir === 'asc' ? 'desc' : 'asc';
    } else {
      this.am_sort_col = col;
      this.am_sort_dir = 'desc';
    }
  }

  am_get_sort_icon(col: string): string {
    if (this.am_sort_col !== col) return 'fa-sort';
    return this.am_sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  am_get_sort_color(col: string): string {
    return this.am_sort_col === col ? '#667eea' : '#adb5bd';
  }

  // ── 明細彈窗排序 ──
  am_detail_toggle_sort(col: string) {
    if (this.am_detail_sort_col === col) {
      this.am_detail_sort_dir = this.am_detail_sort_dir === 'asc' ? 'desc' : 'asc';
    } else {
      this.am_detail_sort_col = col;
      this.am_detail_sort_dir = 'desc';
    }
    this.am_sort_detail_list();
    this.am_detail_page = 1;
  }

  am_detail_get_sort_icon(col: string): string {
    if (this.am_detail_sort_col !== col) return 'fa-sort';
    return this.am_detail_sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  am_detail_get_sort_color(col: string): string {
    return this.am_detail_sort_col === col ? '#667eea' : '#adb5bd';
  }

  private am_sort_detail_list() {
    if (!this.am_detail_sort_col) return;
    const dir = this.am_detail_sort_dir === 'desc' ? -1 : 1;
    const col = this.am_detail_sort_col;
    this.am_detail_list.sort((a: any, b: any) => {
      const va = a[col] ?? '';
      const vb = b[col] ?? '';
      if (typeof va === 'string') return va.localeCompare(vb) * dir;
      return (va - vb) * dir;
    });
  }

  get_gender_label(g: number): string {
    return g === 1 ? '男' : g === 2 ? '女' : '未設定';
  }

  get_online_label(s: number): string {
    return s === 2 ? '在線' : s === 1 ? '忙碌' : '離線';
  }

  get_online_class(s: number): string {
    return s === 2 ? 'text-success' : s === 1 ? 'text-warning' : 'text-muted';
  }

  // ── 文章詳情 modal ────────────────────────────────────────
  detail_posts: any[] = [];
  detail_page = 1;
  detail_page_size = 10;
  detail_total = 0;
  detail_title = '';
  show_detail = false;
  detail_stat_id = '';
  detail_field = '';
  detail_sort_column = 'like_count';
  detail_sort_dir = 'desc';

  constructor(public httpClient: HttpClient) {}

  ngOnInit() {
    this.am_date_start = moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.am_date_end = moment().format('YYYY-MM-DD');
    this.init_account_list();
    this.init_stats_list();
  }

  choose(tab: string) {
    this.now = tab;
    if (tab === '1') { this.stats_page = 1; this.init_stats_list(); }
    if (tab === '2') { this.load_chart_data(); }
    if (tab === '3') { this.load_agent_metrics(); }
  }

  // ── 帳號管理（前端篩選 + 分頁） ──────────────────────────
  get account_filtered(): any[] {
    return this.account_list_raw.filter(item => {
      if (this.acct_filter_type && item.type !== this.acct_filter_type) return false;
      if (this.acct_filter_agent && item.agent_name !== this.acct_filter_agent) return false;
      if (this.acct_filter_status && item.is_enable !== this.acct_filter_status) return false;
      if (this.acct_filter_keyword) {
        const kw = this.acct_filter_keyword.toLowerCase();
        if (!(item.account_name || '').toLowerCase().includes(kw) &&
            !(item.url || '').toLowerCase().includes(kw)) return false;
      }
      return true;
    });
  }

  get account_paged(): any[] {
    const start = (this.account_page - 1) * this.account_page_size;
    return this.account_filtered.slice(start, start + this.account_page_size);
  }

  get account_total_pages(): number {
    return Math.ceil(this.account_filtered.length / this.account_page_size) || 1;
  }

  account_go_page(p: number) {
    if (p < 1 || p > this.account_total_pages) return;
    this.account_page = p;
  }

  get account_page_list(): number[] {
    return this.build_page_list(this.account_page, this.account_total_pages);
  }

  acct_do_filter() {
    this.account_page = 1;
  }

  acct_reset_filter() {
    this.acct_filter_type = '';
    this.acct_filter_agent = '';
    this.acct_filter_status = '';
    this.acct_filter_keyword = '';
    this.account_page = 1;
  }

  init_account_list() {
    this.loading = true;
    this.httpClient.post<any>('/comm/get_community_account.php', { action: 'list' }).subscribe({
      next: res => {
        this.loading = false;
        if (res && res.status) {
          this.account_list_raw = res.data || [];
          this.vendor_list = res.vendor_list || [];
          if (this.account_page > this.account_total_pages) this.account_page = 1;
        } else {
          this.account_list_raw = [];
          if (res?.msg) alert(res.msg);
        }
      },
      error: () => { this.loading = false; this.account_list_raw = []; }
    });
  }

  // ── Modal 操作 ────────────────────────────────────────────
  close_account_modal() {
    const modal = document.getElementById('accountModal');
    if (modal) {
      modal.classList.remove('show');
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    }
    this.edit_data = null;
  }

  private url_type_rules: { pattern: string, type: string }[] = [
    { pattern: 'instagram.com', type: 'ig' },
    { pattern: 'facebook.com',  type: 'fb' },
    { pattern: 'fb.com',        type: 'fb' },
    { pattern: 'twitter.com',   type: 'twitter' },
    { pattern: 'x.com',         type: 'twitter' },
    { pattern: 'threads.net',   type: 'thread' },
    { pattern: 'youtube.com',   type: 'youtube' },
    { pattern: 'youtu.be',      type: 'youtube' },
    { pattern: 'tiktok.com',    type: 'tiktok' },
  ];

  private detect_type(url: string): string | null {
    const lower = url.toLowerCase();
    for (const r of this.url_type_rules) {
      if (lower.includes(r.pattern)) return r.type;
    }
    return null;
  }

  detect_type_from_url() {
    if (!this.edit_data?.url) return;
    const type = this.detect_type(this.edit_data.url);
    if (type) this.edit_data.type = type;
  }

  detect_filter_type_from_keyword() {
    if (!this.acct_filter_keyword) return;
    const type = this.detect_type(this.acct_filter_keyword);
    if (type) this.acct_filter_type = type;
  }

  open_add_modal() {
    this.edit_data = { ...this.default_data };
    this.show_account_modal();
  }

  open_edit_modal(item: any) {
    this.edit_data = { ...item };
    this.show_account_modal();
  }

  private show_account_modal() {
    setTimeout(() => {
      const modal = document.getElementById('accountModal');
      if (!modal) return;
      modal.classList.add('show');
      modal.style.display = 'block';
      modal.removeAttribute('aria-hidden');
      document.body.classList.add('modal-open');
      if (!document.querySelector('.modal-backdrop')) {
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);
      }
    });
  }

  save_account() {
    if (!this.edit_data.url || !this.edit_data.type) {
      alert('請填寫 URL 和社群類型');
      return;
    }
    this.loading = true;
    const body = { action: this.edit_data.id ? 'update' : 'add', data: this.edit_data };
    this.httpClient.post<any>('/comm/update_community_account.php', body).subscribe({
      next: res => {
        this.loading = false;
        if (res && res.status) {
          this.close_account_modal();
          this.init_account_list();
          if (res.msg) alert(res.msg);
        } else {
          alert(res?.msg || '操作失敗');
        }
      },
      error: () => { this.loading = false; alert('連線失敗，請稍後再試'); }
    });
  }

  toggle_enable(item: any) {
    const new_enable = item.is_enable === '1' ? '0' : '1';
    const body = { action: 'update', data: { ...item, is_enable: new_enable } };
    this.httpClient.post<any>('/comm/update_community_account.php', body).subscribe({
      next: res => { if (res?.status) this.init_account_list(); else alert(res?.msg || '操作失敗'); },
      error: () => { alert('連線失敗'); }
    });
  }

  trigger_crawl(item: any) {
    if (!item.community_id) { alert('此帳號尚未登錄外部系統，無法觸發爬文'); return; }
    if (this.crawling_ids.has(item.id)) return;
    this.crawling_ids.add(item.id);
    this.httpClient.post<any>('/comm/crawl_community.php', { community_id: item.community_id }).subscribe({
      next: res => { this.crawling_ids.delete(item.id); alert(res?.status ? (res.msg || '爬文已觸發') : (res?.msg || '觸發失敗')); },
      error: () => { this.crawling_ids.delete(item.id); alert('連線失敗'); }
    });
  }

  is_crawling(item: any): boolean { return this.crawling_ids.has(item.id); }

  get_type_label(type: string) {
    const found = this.type_options.find(t => t.id === type);
    return found ? found.name : type;
  }

  // ── 每日統計（後端分頁） ────────────────────────────────────
  get stats_total_pages(): number { return Math.ceil(this.stats_total / this.stats_page_size) || 1; }
  get stats_page_list(): number[] { return this.build_page_list(this.stats_page, this.stats_total_pages); }

  stats_go_page(p: number) {
    if (p < 1 || p > this.stats_total_pages || p === this.stats_page) return;
    this.stats_page = p;
    this.init_stats_list();
  }

  toggle_sort(col: string) {
    if (this.sort_column === col) {
      this.sort_dir = this.sort_dir === 'asc' ? 'desc' : 'asc';
    } else {
      this.sort_column = col;
      this.sort_dir = 'desc';
    }
    this.stats_page = 1;
    this.init_stats_list();
  }

  get_sort_icon(col: string): string {
    if (this.sort_column !== col) return 'fa-sort';
    return this.sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  init_stats_list() {
    this.loading = true;
    const body = {
      page: this.stats_page - 1, count: this.stats_page_size,
      date_start: this.filter_date_start, date_end: this.filter_date_end,
      type: this.filter_type, agent: this.filter_agent, keyword: this.filter_keyword,
      sort_column: this.sort_column, sort_dir: this.sort_dir,
    };
    this.httpClient.post<any>('/comm/get_community_stats.php', body).subscribe({
      next: res => {
        this.loading = false;
        if (res && res.status) { this.stats_list = res.data || []; this.stats_total = res.total_count ?? this.stats_list.length; }
        else { this.stats_list = []; this.stats_total = 0; }
      },
      error: () => { this.loading = false; this.stats_list = []; this.stats_total = 0; }
    });
  }

  do_filter() { this.stats_page = 1; this.init_stats_list(); }
  reset_filter() {
    this.filter_date_start = ''; this.filter_date_end = '';
    this.filter_type = ''; this.filter_agent = ''; this.filter_keyword = '';
    this.stats_page = 1; this.init_stats_list();
  }

  // ── 文章詳情（後端分頁） ──────────────────────────────────
  get detail_total_pages(): number { return Math.ceil(this.detail_total / this.detail_page_size) || 1; }
  get detail_page_list(): number[] { return this.build_page_list(this.detail_page, this.detail_total_pages); }

  detail_go_page(p: number) {
    if (p < 1 || p > this.detail_total_pages || p === this.detail_page) return;
    this.detail_page = p; this.load_detail();
  }

  toggle_detail_sort(col: string) {
    if (this.detail_sort_column === col) {
      this.detail_sort_dir = this.detail_sort_dir === 'asc' ? 'desc' : 'asc';
    } else {
      this.detail_sort_column = col;
      this.detail_sort_dir = 'desc';
    }
    this.detail_page = 1;
    this.load_detail();
  }

  get_detail_sort_icon(col: string): string {
    if (this.detail_sort_column !== col) return 'fa-sort';
    return this.detail_sort_dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  open_detail(stat: any, field: string) {
    this.detail_title = `${stat.target_date} ${stat.account_name} — ${this.field_label(field)}`;
    this.detail_stat_id = stat.id; this.detail_field = field; this.detail_page = 1;
    this.detail_sort_column = 'like_count'; this.detail_sort_dir = 'desc';
    this.show_detail = true; this.load_detail();
  }

  load_detail() {
    this.loading = true;
    const body = {
      stat_id: this.detail_stat_id, field: this.detail_field,
      page: this.detail_page - 1, count: this.detail_page_size,
      sort_column: this.detail_sort_column, sort_dir: this.detail_sort_dir,
    };
    this.httpClient.post<any>('/comm/get_community_posts.php', body).subscribe({
      next: res => {
        this.loading = false;
        if (res?.status) { this.detail_posts = res.data || []; this.detail_total = res.total_count ?? this.detail_posts.length; }
        else { this.detail_posts = []; this.detail_total = 0; }
      },
      error: () => { this.loading = false; this.detail_posts = []; this.detail_total = 0; }
    });
  }

  close_detail() { this.show_detail = false; this.detail_posts = []; this.detail_total = 0; }

  field_label(field: string): string {
    const map: any = { post_count: '發文數', like_count: '點讚數', view_count: '觀看次數', comment_count: '留言數', share_count: '分享次數' };
    return map[field] || field;
  }

  // ── 圖表分析 ────────────────────────────────────────────
  load_chart_data() {
    this.loading = true;
    this.chart_ready = false;
    const body = {
      date_start: this.chart_filter_date_start,
      date_end: this.chart_filter_date_end,
    };
    this.httpClient.post<any>('/comm/get_community_chart_stats.php', body).subscribe({
      next: res => {
        this.loading = false;
        if (res?.status && res.data) {
          this.build_agent_pie(res.data.agent_contribution || []);
          this.agent_platform_data = res.data.agent_platform || [];
          if (this.agent_platform_data.length > 0 && !this.chart_selected_agent) {
            this.chart_selected_agent = this.agent_platform_data[0].agent;
          }
          this.build_platform_pie();
          this.trend_raw = res.data.agent_trend || { dates: [], metrics: {} };
          this.update_trend_platform_options();
          this.build_trend_line();
          setTimeout(() => { this.chart_ready = true; });
        }
      },
      error: () => { this.loading = false; }
    });
  }

  chart_do_filter() {
    this.load_chart_data();
  }

  chart_reset_filter() {
    this.chart_filter_date_start = '';
    this.chart_filter_date_end = '';
    this.chart_selected_agent = '';
    this.trend_platform = '';
    this.load_chart_data();
  }

  platform_chart_visible = true;

  on_agent_select_change() {
    this.platform_chart_visible = false;
    this.build_platform_pie();
    setTimeout(() => { this.platform_chart_visible = true; });
  }

  build_agent_pie(data: any[]) {
    const pieData = data.map(d => ({ name: d.name, y: d.value }));
    this.agentPieOptions = {
      chart: { type: 'pie', height: 400 },
      title: { text: '各經紀總貢獻占比' },
      credits: { enabled: false },
      tooltip: {
        pointFormat: '<b>{point.y:,.0f}</b> ({point.percentage:.1f}%)'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f}%'
          },
          showInLegend: true
        }
      },
      series: [{
        name: '貢獻量',
        type: 'pie',
        data: pieData
      }]
    };
    this.agentPieUpdateFlag = true;
  }

  build_platform_pie() {
    const found = this.agent_platform_data.find(d => d.agent === this.chart_selected_agent);
    if (!found) {
      this.platformPieOptions = {
        chart: { type: 'pie', height: 400 },
        title: { text: '經紀社群占比 — 請選擇經紀' },
        credits: { enabled: false },
        series: [{ name: '占比', type: 'pie', data: [] }]
      };
      this.platformPieUpdateFlag = true;
      return;
    }
    const pieData = found.breakdown.map((b: any) => ({
      name: this.get_type_label(b.type),
      y: b.value
    }));
    this.platformPieOptions = {
      chart: { type: 'pie', height: 400 },
      title: { text: this.chart_selected_agent + ' — 各社群占比' },
      credits: { enabled: false },
      tooltip: {
        pointFormat: '<b>{point.y:,.0f}</b> ({point.percentage:.1f}%)'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f}%'
          },
          showInLegend: true
        }
      },
      series: [{
        name: '社群貢獻',
        type: 'pie',
        data: pieData
      }]
    };
    this.platformPieUpdateFlag = true;
  }

  trend_chart_visible = true;

  switch_trend_metric(metric: string) {
    this.trend_metric = metric;
    this.update_trend_platform_options();
    this.rebuild_trend_chart();
  }

  switch_trend_platform(platform: string) {
    this.trend_platform = platform;
    this.rebuild_trend_chart();
  }

  private rebuild_trend_chart() {
    this.trend_chart_visible = false;
    this.build_trend_line();
    setTimeout(() => { this.trend_chart_visible = true; });
  }

  get trend_metric_label(): string {
    const found = this.trend_metrics.find(m => m.key === this.trend_metric);
    return found ? found.label : '';
  }

  // 從 trend_raw 中提取出有哪些平台（用於 filter 下拉）
  private update_trend_platform_options() {
    const platforms = new Set<string>();
    const allSeries = this.trend_raw.metrics?.[this.trend_metric] || [];
    allSeries.forEach((s: any) => {
      // series name 格式: "經紀 - platform_type"
      const parts = s.name.split(' - ');
      if (parts.length >= 2) {
        platforms.add(parts[parts.length - 1].trim());
      }
    });
    this.trend_platform_options = Array.from(platforms).map(p => {
      const t = this.type_options.find(t => t.id === p);
      return { id: p, name: t ? t.name : p };
    });
  }

  build_trend_line() {
    const metricSeries = this.trend_raw.metrics?.[this.trend_metric] || [];
    // 如果有選平台，只顯示該平台的線
    const filtered = this.trend_platform
      ? metricSeries.filter((s: any) => {
          const parts = s.name.split(' - ');
          const pt = parts[parts.length - 1].trim();
          return pt === this.trend_platform;
        })
      : metricSeries;
    const series = filtered.map((s: any) => ({
      name: s.name,
      type: 'line',
      data: s.data
    }));
    this.trendLineOptions = {
      chart: { type: 'line', height: 450 },
      title: { text: '經紀各社群 — ' + this.trend_metric_label },
      credits: { enabled: false },
      xAxis: {
        categories: this.trend_raw.dates || [],
        labels: { rotation: -45, style: { fontSize: '11px' } }
      },
      yAxis: {
        title: { text: this.trend_metric_label },
        labels: {
          formatter: function () {
            return Highcharts.numberFormat(this.value as number, 0, '.', ',');
          }
        }
      },
      tooltip: {
        shared: true,
        formatter: function () {
          let s = '<b>' + this.x + '</b><br/>';
          this.points.forEach(p => {
            s += '<span style="color:' + p.color + '">\u25CF</span> '
              + p.series.name + ': <b>' + Highcharts.numberFormat(p.y, 0, '.', ',') + '</b><br/>';
          });
          return s;
        }
      },
      plotOptions: {
        line: {
          dataLabels: { enabled: false },
          marker: { enabled: true, radius: 3 }
        }
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
      },
      series: series
    };
    this.trendLineUpdateFlag = true;
  }

  open_url(url: string) { window.open(url, '_blank'); }

  private build_page_list(current: number, total: number): number[] {
    const pages: number[] = [];
    let start = Math.max(1, current - 2);
    let end = Math.min(total, start + 4);
    start = Math.max(1, end - 4);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  }

  // ── 經紀指標 ────────────────────────────────────────────
  load_agent_metrics() {
    this.loading = true;
    this.am_chart_ready = false;
    const body = {
      date_start: this.am_date_start,
      date_end: this.am_date_end,
    };
    this.httpClient.post<any>('/comm/get_community_agent_metrics.php', body).subscribe({
      next: res => {
        this.loading = false;
        if (res?.status && res.data) {
          this.am_summary_raw = res.data.summary || [];
          this.am_pie_raw = res.data.pie_new_users || [];
          this.am_trend_raw_full = res.data.trend || { dates: [], new_users: [], post_count: [] };
          this.am_apply_vendor_filter();
          this.load_income_radar(() => {
            setTimeout(() => { this.am_chart_ready = true; });
          });
        }
      },
      error: () => { this.loading = false; }
    });
  }

  am_apply_vendor_filter() {
    const v = this.am_filter_vendor;
    // 過濾 summary（getter 已處理）, 重建圖表用過濾後的資料
    const filtered = this.am_summary;

    // pie
    const pie = v ? this.am_pie_raw.filter((d: any) => d.name === v) : this.am_pie_raw;
    this.build_am_pie(pie);

    // bar
    this.build_am_bar(filtered);

    // trend
    const full = this.am_trend_raw_full;
    if (v) {
      this.am_trend_raw = {
        dates: full.dates,
        new_users: (full.new_users || []).filter((s: any) => s.name === v),
        post_count: (full.post_count || []).filter((s: any) => s.name === v),
      };
    } else {
      this.am_trend_raw = full;
    }
    this.build_am_trend();
  }

  am_on_vendor_change() {
    this.am_chart_ready = false;
    this.am_apply_vendor_filter();
    this.load_income_radar(() => {
      setTimeout(() => { this.am_chart_ready = true; });
    });
  }

  am_handleRangeSelected(event: any) {
    const e = event.event;
    if (e && e.startDate && e.endDate) {
      this.am_date_start = moment(e.startDate).format('YYYY-MM-DD');
      this.am_date_end = moment(e.endDate).format('YYYY-MM-DD');
      this.load_agent_metrics();
    }
  }

  am_do_filter() { this.load_agent_metrics(); }

  am_reset_filter() {
    this.am_time = { startDate: moment().subtract(7, 'days'), endDate: moment() };
    this.am_date_start = moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.am_date_end = moment().format('YYYY-MM-DD');
    this.am_filter_vendor = '';
    this.load_agent_metrics();
  }

  am_switch_metric(key: string) {
    this.am_trend_metric = key;
    this.am_trend_visible = false;
    this.build_am_trend();
    setTimeout(() => { this.am_trend_visible = true; });
  }

  private build_am_pie(data: any[]) {
    const pieData = data.map(d => ({ name: d.name, y: d.y }));
    this.am_pie_options = {
      chart: { type: 'pie', height: 400 },
      title: { text: '各經紀新增用戶占比' },
      credits: { enabled: false },
      tooltip: { pointFormat: '<b>{point.y:,.0f}</b> ({point.percentage:.1f}%)' },
      plotOptions: {
        pie: {
          allowPointSelect: true, cursor: 'pointer',
          dataLabels: { enabled: true, format: '<b>{point.name}</b>: {point.percentage:.1f}%' },
          showInLegend: true
        }
      },
      series: [{ name: '新增用戶', type: 'pie', data: pieData }]
    };
    this.am_pie_update = true;
  }

  private build_am_bar(summary: any[]) {
    const names = summary.map((s: any) => s.vendor_name);
    const activeRates = summary.map((s: any) => s.active_rate);
    const churns = summary.map((s: any) => s.churn_rate);
    this.am_bar_options = {
      chart: { type: 'bar', height: 400 },
      title: { text: '各經紀活躍率 / 流失率' },
      credits: { enabled: false },
      xAxis: { categories: names, title: { text: null } },
      yAxis: { min: 0, max: 100, title: { text: '百分比 (%)' } },
      tooltip: { valueSuffix: ' %' },
      plotOptions: { bar: { dataLabels: { enabled: true, format: '{y}%' } } },
      legend: { reversed: true },
      series: [
        { name: '活躍率', type: 'bar', data: activeRates, color: '#28a745' },
        { name: '流失率', type: 'bar', data: churns, color: '#dc3545' }
      ]
    };
    this.am_bar_update = true;
  }

  // ── 雷達圖 ──
  load_income_radar(cb?: () => void) {
    const body: any = {
      date_start: this.am_date_start,
      date_end: this.am_date_end,
    };
    const vendor = this.am_filter_vendor;
    if (vendor) {
      const v = this.am_summary_raw.find((r: any) => r.vendor_name === vendor);
      if (v) body.vid = v.vid;
    }
    this.httpClient.post<any>('/comm/get_community_income_radar.php', body).subscribe({
      next: res => {
        if (res?.status && res.data) {
          this.am_radar_raw = res.data;
          this.build_am_radar();
        }
        if (cb) cb();
      },
      error: () => { if (cb) cb(); }
    });
  }

  private build_am_radar() {
    const categories = ['語音', '視訊', '文字', '動態', '其他'];
    const colorSets = [
      { line: '#667eea', fill: 'rgba(102,126,234,0.2)' },
      { line: '#28a745', fill: 'rgba(40,167,69,0.2)' },
      { line: '#ff6b6b', fill: 'rgba(255,107,107,0.2)' },
      { line: '#f0932b', fill: 'rgba(240,147,43,0.2)' },
      { line: '#6c5ce7', fill: 'rgba(108,92,231,0.2)' },
      { line: '#e17055', fill: 'rgba(225,112,85,0.2)' },
      { line: '#00cec9', fill: 'rgba(0,206,201,0.2)' },
      { line: '#fd79a8', fill: 'rgba(253,121,168,0.2)' },
    ];

    // 計算所有數值的最大值，判斷是否需要對數刻度
    const allVals: number[] = [];
    this.am_radar_raw.forEach((r: any) => {
      [r.voice, r.video, r.text, r.dynamic, r.other].forEach((v: number) => {
        if (v > 0) allVals.push(v);
      });
    });
    const maxVal = allVals.length ? Math.max(...allVals) : 0;
    const minVal = allVals.length ? Math.min(...allVals) : 0;
    const useLog = maxVal > 0 && minVal > 0 && (maxVal / minVal) > 20;

    const series: any[] = this.am_radar_raw.map((r: any, i: number) => {
      const c = colorSets[i % colorSets.length];
      const rawData = [r.voice, r.video, r.text, r.dynamic, r.other];
      return {
        name: r.vendor_name,
        type: 'area',
        data: rawData.map(v => ({ y: useLog ? (v > 0 ? v : 1) : v, raw: v })),
        pointPlacement: 'on',
        color: c.line,
        fillColor: c.fill,
        lineWidth: 2.5,
        marker: {
          enabled: true,
          radius: 5,
          symbol: 'circle',
          fillColor: '#fff',
          lineWidth: 2.5,
          lineColor: c.line,
        },
        dataLabels: {
          enabled: true,
          formatter: function() { return Highcharts.numberFormat((this.point as any).raw ?? this.y, 0, '.', ','); },
          style: { fontSize: '11px', fontWeight: '600', color: '#495057', textOutline: '2px white' },
          padding: 4,
          y: -10,
        },
      };
    });

    this.am_radar_options = {
      chart: {
        polar: true,
        type: 'area',
        height: 460,
        backgroundColor: 'transparent',
        style: { fontFamily: '\'Noto Sans TC\', \'Microsoft JhengHei\', sans-serif' },
      },
      title: { text: null },
      credits: { enabled: false },
      pane: {
        size: '70%',
        background: [{
          backgroundColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [[0, 'rgba(248,249,250,0.8)'], [1, 'rgba(233,236,239,0.4)']],
          },
          borderColor: '#dee2e6',
          borderWidth: 1,
        }],
      },
      xAxis: {
        categories: categories,
        tickmarkPlacement: 'on',
        lineWidth: 0,
        labels: {
          style: { fontSize: '14px', fontWeight: '700', color: '#343a40' },
          distance: 25,
        },
        gridLineColor: 'rgba(0,0,0,0.1)',
      },
      yAxis: {
        type: useLog ? 'logarithmic' : 'linear',
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: useLog ? 1 : 0,
        gridLineColor: 'rgba(0,0,0,0.06)',
        tickAmount: 5,
        labels: {
          style: { fontSize: '10px', color: '#adb5bd' },
          formatter: function() {
            const v = this.value as number;
            if (v >= 1000000) return (v / 1000000).toFixed(1) + 'M';
            if (v >= 1000) return (v / 1000).toFixed(0) + 'K';
            return Highcharts.numberFormat(v, 0, '.', ',');
          }
        }
      },
      tooltip: {
        shared: true,
        useHTML: true,
        backgroundColor: 'rgba(255,255,255,0.97)',
        borderColor: '#dee2e6',
        borderRadius: 10,
        shadow: { color: 'rgba(0,0,0,0.1)', offsetX: 0, offsetY: 4, width: 12 },
        style: { fontSize: '13px' },
        formatter: function () {
          let s = '<div style="font-weight:700;margin-bottom:6px;font-size:14px;">' + this.x + '</div>';
          this.points.forEach((p: any) => {
            const val = p.point.raw ?? p.y;
            s += '<div style="display:flex;align-items:center;gap:6px;padding:3px 0;">'
              + '<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:' + p.color + ';"></span> '
              + '<span>' + p.series.name + '</span>'
              + '<span style="margin-left:auto;font-weight:700;">' + Highcharts.numberFormat(val, 0, '.', ',') + '</span>'
              + '</div>';
          });
          return s;
        }
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        itemStyle: { fontSize: '13px', fontWeight: '500', color: '#495057' },
        symbolRadius: 6,
      },
      series: series,
    };
    this.am_radar_update = true;
  }

  private build_am_trend() {
    const metricKey = this.am_trend_metric;
    const seriesRaw = this.am_trend_raw[metricKey] || [];
    const label = this.am_trend_metrics.find(m => m.key === metricKey)?.label || '';
    const series = seriesRaw.map((s: any) => ({ name: s.name, type: 'line', data: s.data }));
    this.am_trend_options = {
      chart: { type: 'line', height: 450 },
      title: { text: '經紀每日趨勢 — ' + label },
      credits: { enabled: false },
      xAxis: {
        categories: this.am_trend_raw.dates || [],
        labels: { rotation: -45, style: { fontSize: '11px' } }
      },
      yAxis: { title: { text: label }, min: 0 },
      tooltip: {
        shared: true,
        formatter: function () {
          let s = '<b>' + this.x + '</b><br/>';
          this.points.forEach(p => {
            s += '<span style="color:' + p.color + '">\u25CF</span> '
              + p.series.name + ': <b>' + Highcharts.numberFormat(p.y, 0, '.', ',') + '</b><br/>';
          });
          return s;
        }
      },
      plotOptions: { line: { marker: { enabled: true, radius: 3 } } },
      legend: { layout: 'horizontal', align: 'center', verticalAlign: 'bottom' },
      series: series
    };
    this.am_trend_update = true;
  }
}
